<template>
  <RedesignWebccPopupDialog v-bind="$attrs" @close="handleClose">
    <template #button>
      <RedesignWebccSelectButton
        icon="site/pax"
        :text
        class="w-full min-w-[14.75rem]"
        @clear="handleClear"
      />
    </template>

    <template #default="{ toggle }">
      <header
        class="flex items-center justify-center border-b border-bgr-300 p-3 md:p-4 md:hidden max-md:bg-bgr-100"
      >
        <h1 class="text-xl font-medium">{{ $t(`${trPrefix}pax_s`) }}</h1>

        <button
          class="absolute right-4 rounded-full p-1 transition focus:bg-bgr-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-thm-hover focus:border-thm-hover"
          @click="apply(toggle)"
        >
          <WebccIcon name="site/x" class="h-6 w-6 text-txt-weak" />
        </button>
      </header>

      <main class="flex flex-col p-6 gap-8 min-w-[22rem]">
        <label class="flex justify-between items-center">
          <span>{{ $t(`${trPrefix}placeholders.pax`) }}</span>

          <RedesignWebccStepper
            v-model="pax"
            name="pax"
            :min="PAX_MIN"
            :max="PAX_MAX"
          />
        </label>

        <label class="flex justify-between items-center">
          <span>{{ $t(`${trPrefix}placeholders.pets`) }}</span>

          <RedesignWebccStepper
            v-model="pets"
            name="pets"
            :min="PETS_MIN"
            :max="PETS_MAX"
          />
        </label>
      </main>

      <footer
        class="absolute bottom-0 flex w-full justify-end border-t border-bgr-300 p-3 md:p-4 md:static max-md:bg-bgr-100"
      >
        <WebccButton
          variant="theme"
          class="w-full md:w-auto !py-2.5 !px-3 !text-base"
          @click="apply(toggle)"
        >
          {{ $t(`${trPrefixDates}apply`) }}
        </WebccButton>
      </footer>
    </template>
  </RedesignWebccPopupDialog>
</template>

<script setup lang="ts">
import { PAX_MIN, PAX_MAX, PETS_MIN, PETS_MAX } from '~/utils/filters'

const trPrefix = 'www.components.elements.SearchBox.'
const trPrefixDates = 'www.components.elements.SearchDates.'

const emit = defineEmits<{
  change: [guests: GuestsValue]
}>()

const model = defineModel<GuestsValue>({
  default: { pax: PAX_MIN, pets: PETS_MIN },
})

const { t } = useI18n()

const pax = propToRef(model, 'pax', PAX_MIN)
const pets = propToRef(model, 'pets', PETS_MIN)

const text = computed(() => {
  if (model.value.pets === PETS_MIN)
    return t(`${trPrefix}pax_s`, model.value.pax)

  return `${t(`${trPrefix}pax_s`, model.value.pax)}, ${t(`${trPrefix}pet_s`, model.value.pets)}`
})

function apply(toggle: (value?: boolean | undefined) => void) {
  toggle(false)
}

function handleClose() {
  emit('change', { pax: pax.value, pets: pets.value })
}

function handleClear() {
  pax.value = PAX_MIN
  pets.value = PETS_MIN
  emit('change', { pax: pax.value, pets: pets.value })
}
</script>
